import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"
import { currentEnvironment } from "@porsche-customer/slfinrtl-environment"
import type { Environment, FeatureToggle, MarketplaceConfig } from "@slfinrtl/feature-config"
// eslint-disable-next-line no-restricted-imports
import { environmentFeatureToggles, getMarketplaceConfig as getMarketplaceConfigFunc } from "@slfinrtl/feature-config"

const getEnv = (): Environment => {
	const env = currentEnvironment()
	switch (env) {
		case null:
		case "local":
			return "dev"
		default:
			return env
	}
}
export const getFeatureToggle = (featureToggle: FeatureToggle): boolean =>
	environmentFeatureToggles[featureToggle].includes(getEnv())

export const getMarketplaceConfig = (marketplaceKey: MarketplaceKey): MarketplaceConfig =>
	getMarketplaceConfigFunc(marketplaceKey, getEnv())
